import { methodGet, methodDelete, methodPost, methodPut, methodPatch } from './methods';
import { API_INFO } from '../constants';

//Get

export async function getGallery() {
  return methodGet(API_INFO + 'company/gallery');
}

export async function getGalleryCategories() {
  return methodGet(API_INFO + 'company/gallery/categories');
}

export async function getPaginatedGallery(payload) {
  return methodGet(API_INFO + 'company/gallery/paginated/', payload);
}

export async function getGalleryItem(id) {
  return methodGet(API_INFO + `company/gallery/${id}`);
}

//Post

export async function createGallery(payload) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return methodPost(API_INFO + 'company/gallery/', payload, config);
}

//Put

export async function editGalleryFirst(id, payload) {
  return methodPut(API_INFO + `company/gallery/${id}`, payload);
}

//Patch

export async function editGallery(id, payload) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return methodPatch(API_INFO + `company/gallery/${id}/`, payload, config);
}

//Delete

export async function deleteGallery(id) {
  return methodDelete(API_INFO + `company/gallery/${id}`);
}
